import { ServicePointBalanceServiceMock } from "./servicePointBalance.types";

export const mockServicePointBalanceService = (): ServicePointBalanceServiceMock => ({
  fetchServicePointBalances: jest.fn(),
  fetchServicePointBalanceById: jest.fn(),
  fetchServicePointBalancesV2: jest.fn(),
  fetchServicePointBalanceByIdV2: jest.fn(),
  fetchServicePointByIdV2: jest.fn(),
});
